var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9988 20.0012V24.0012M23.9988 28.0012H24.0088M22.2888 14.8612L13.8188 29.0012C13.6442 29.3036 13.5518 29.6465 13.5508 29.9957C13.5498 30.3449 13.6403 30.6883 13.8132 30.9917C13.9862 31.2951 14.2355 31.5479 14.5365 31.725C14.8375 31.9021 15.1796 31.9973 15.5288 32.0012H32.4688C32.818 31.9973 33.1601 31.9021 33.4611 31.725C33.7621 31.5479 34.0114 31.2951 34.1844 30.9917C34.3573 30.6883 34.4478 30.3449 34.4468 29.9957C34.4458 29.6465 34.3534 29.3036 34.1788 29.0012L25.7088 14.8612C25.5305 14.5673 25.2795 14.3243 24.98 14.1557C24.6805 13.987 24.3425 13.8984 23.9988 13.8984C23.6551 13.8984 23.3171 13.987 23.0176 14.1557C22.7181 14.3243 22.4671 14.5673 22.2888 14.8612Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fe787c143017ed032c91f30ff5956477.svg";
export { ForwardRef as ReactComponent };